import { Component, Vue, Watch } from 'vue-property-decorator'
import { ladderRatioCheck, ladderItemError, souCoueTypeList, formRules } from './data'
import {
    getMarketCooperationPrevLevel,
    getProjectDissertationList,
    setMarketCooperation,
    duplicateCheckMarketCooperation,
    getProjectAllGroupPriceListBySouCourseTypeId,
    getProjectAllListBySouCourseTypeId,
    getMarketCooperationById,
    setMarketCooperationById,
    getPrevMarketCooperationById
} from '@/api/market'
import { UserModule } from '@/store/modules/user'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {  payInfoList, getBranchList } from '@/api/common'
import {setPayeeInfo} from "@/api/financial-center";
import {getAgeByCardId} from "@/utils/checkIDCard";
import CommonData from "@/utils/commonData";


interface PartnerInfo {
    [x: string]: any;
    name: string; // 合作方名称
    marketCooperationId?: number; // 关联上级id
    source: string; // 来源
    types: string;  // 合作方类型
    contact: string; // 机构联系人
    contactInfo: string; // 联系方式
    contractType: string; // 合同类型
    city: string; // 机构所在城市
    // 佣金信息
    marketCooperationCommissionList?: {
        souCourseTypeIdList?: any[]; // 项目类型组合
        souCourseTypeName?: string; // 项目类型的名称
        commissionType: string; // 佣金类型
        rebateType?: string; // 返点类型
        priceOrRebateRatio?: string; // 结算价或返点比例
        // 返佣范围数据
        rebateRatioList?: {
            startCondition: string; // 开始条件
            startNum: number; // 数量
            endConditionL?: string; // 结束条件
            endNum?: number; //数量
            rebateRatio: string; // 返佣比例
        }[];
        // 结算价设置 by originalPrice
        projectAllGroupPriceList?: {
            originalPrice: string; // 原价
            price: string; // 结算价
        }[];
        // 结算价设置 by id
        projectAllList?: {
            id: number; // 项目id
            price: string; // 结算价
        }[];
    }[];
    // 论文项目佣金设置
    projectDissertationCommissionList?: {
        projectDissertationId: number; // 论文项目id
        commissionType: string; // 佣金类型
        priceOrRebateRatio?: string; // 结算价或返点比例
        name?: string; // 论文项目名称
    }[];
    invoiceType: string; // 开票类型
    invoiceTitle: string; // 开票抬头
    invoiceCode: string; // 纳税识别号
    invoiceBank: string; // 开户行
    invoiceAccount: string; // 开户账号
    invoiceAddress: string; // 开户地址
    invoicePhone: string; // 联系方式
    directorUserId: string; // 负责人id
    shareUserIdList: string[]; // 共享人员 id
    signAt: string; // 签约时间
    isAsync: string; // 是否同步下级
    adviserList: object[];// 送生顾问信息
    backMoneyType: string; // 回款类型
    signType: string; // 客户签署类型
    provinceAndCityData: object[];
}
@Component({
    components:{
        MoreUsersFilter
    }
})
export default class NewPartner extends Vue {
    oldSouCourseTypeIdList: number[] = [] // 项目类型编辑旧id
    oldIdList: number[] = [] // 项目类型编辑旧id
    addProject = false
    checkedLeval = false //同步下级
    conditionList = ['大于', '小于', '等于', '大于等于', '小于等于']
    // 合作伙伴数据信息
    partnerInfo: PartnerInfo = {
        name: '',
        marketCooperationId: undefined,
        source: '',
        types: '',
        contact: '',
        contactInfo: '',
        contractType: '',
        marketCooperationCommissionList: [
            {
                souCourseTypeName: '',
                souCourseTypeIdList: [],
                commissionType: '',
                rebateType: '',
                priceOrRebateRatio: '',
                rebateRatioList: [],
                projectAllGroupPriceList: [],
                projectAllList: [],
            }
        ],
        projectDissertationCommissionList: [],
        invoiceType: '',
        invoiceTitle: '',
        invoiceCode: '',
        invoiceBank: '',
        invoiceAccount: '',
        invoiceAddress: '',
        invoicePhone: '',
        directorUserId: '',
        shareUserIdList: [],
        signAt: '',
        isAsync: '', // 是否同步下级
        adviserList: [],
        city: '',
        backMoneyType: '',
        signType: '',
        provinceAndCityData: []
    }
    createUserRealName = ''
    marketCooperationIdList = [] // 关联上级数据
    marketCooperationIdListIsLoading = false
    souCourseTypeIdList: number[] = [] // 当前选中的项目类型id
    souCoueTypeList = souCoueTypeList
    rules = formRules
    repeatTableData = []
    repeatDialogShow = false
    repeatErrortext = ''
    projectTypeDialogShow = false
    projectTypeDialogTitle = ''
    projectTypeTableData = []
    projectTypeTableData_ = []
    projectPriceDialogShow = false
    editProjectTypePriceDialogShow = false
    projectPricetableData = [] // 项目列表
    projectPricetableHeadData = [
        { label: '项目编号', prop: 'souCourseIndex' },
        { label: '项目名称', prop: 'souCourseName' },
        // { label: '双课题备注', prop: 'doubleSouCourseName' },
        { label: '开课时间', prop: 'date' },
        { label: '导师名字', prop: 'souTeacherName' },
        { label: '项目定价', prop: 'souCoursePrice' },
        { label: '结算价', prop: 'price' },
    ]
    projectPriceFilterObj = {
        souCourseName: '',
        schoolBeginAt: [],
        souTeacherName: '',
        souCoursePrice: '',
        page: 1,
        limit: 20,
    }
    total = 0
    dialogSouCourseTypeId: number[] = [] // 当前展示的结算价弹框的 项目类型ID
    partnerId: number = null
    oldMarketCooperationCommissionList = [] // 佣金信息 --- 编辑的时候使用，验证数据是否发生改变
    oldProjectDissertationCommissionList = [] // 论文信息 --- 编辑的时候使用，验证数据是否发生改变
    errorDialogShow = false
    isUpdatedData = '0' // 是否查看新数据
    disabledButton = false
    tableKey = Math.random()
    isImport = false // 当前数据是不是批量导入的数据
    marketLevelPage = 1
    marketLevelSize = 20
    cooperativePartnerName = ''
    sourceName = ''
    sourceNameId = null
    addMarketSelectList = []
    adviserList = [
        { name: '' }
    ]
    ratioPrice =null
    ratioPrice_ =null
    oldShareUserIdList=[]
    directorUserName = ''
    shareUserList = []
    newAccountDialog = false
    searchName: any =null //开户名称
    searchCardName: any =null //银行卡号
    searchBranchName: any = null //开户网点
    branchInfoList = [] // 开户网点数据
    branchPage = 1
    branchLimit = 20
    payInfo: any = {
        name: '',
        cardNum: '',
        branch: '',
        type: '',
        page: 1,
        limit: 20,
        id: '',
        selectedArea: [],
        selectedDetailArea: ''
    }
    // accountEditBtn = false
    payeeInfoList = [] // 开户名称数据
    payInfoLoading = false
    accountTypeList = [
        {value: 'PUBLIC', label: '对公账户'},
        {value: 'PERSONAL', label: '个人账户'},
    ]
    syncDialogVisible = false
    msg = ''
    type = '' //账户类型
    name = '' //开户名称
    cardNum = '' //银行卡号
    branch = '' //开户网点
    phoneNo = '' //手机号
    certificateNo = '' // 身份证号
    certificateNoDisabled = true
    phoneNoDisabled = true
    marketCooperationAccount = null
    loading = false
    options = CommonData.regionData
    selectedOptions = []
    // 用户名
    get userModuleData() {
       return {
            username: UserModule.userName,
            userid: UserModule.userId,
        }
    }

    // 当前选中的项目类型 ID
    get checkedProjectTypeIdList() {
        let idList: number[] = []
        const marketCooperationCommissionList = this.partnerInfo.marketCooperationCommissionList
        marketCooperationCommissionList.forEach(item => {
            idList = idList.concat(item.souCourseTypeIdList)
        })
        return idList
    }

    // 项目类型是否可选
    projectTypeIsChoose(id: number, index: number) {
        const idList = JSON.parse(JSON.stringify(this.checkedProjectTypeIdList))
        this.partnerInfo.marketCooperationCommissionList.forEach((item, i) => {
            if(i === index) {
                item.souCourseTypeIdList.forEach(souCourseTypeId => {
                    idList.splice(idList.indexOf(souCourseTypeId), 1)
                })
            }
        })
        return idList.includes(id)
    }

    created() {

        // this.souCourseTypeIdList = this.partnerInfo.marketCooperationCommissionList.map(item => ...item.souCourseTypeIdList).filter(item => item)
        // this.partnerInfo.marketCooperationCommissionList.forEach(item => {
        //     this.souCourseTypeIdList.concat(item.souCourseTypeIdList)
        // })
        const query = this.$route.query
        if (query.type) {
            this.isUpdatedData = query.type as string
        }
        if (query.id) {
            this.partnerId = Number(query.id)
            this.getMarketCooperationById()
        }
        this.getMarketCooperationPrevLevel()
        this.getProjectDissertationList()
        // this.options = regionData.map(item => {
        //     return {
        //       value: item.value,
        //       label: item.label
        //     }
        // })
    }

  /*
  * 批量设置结算价*/
    //未设置
    handelNoSetAllPrice(){
        this.projectTypeTableData.forEach(item=>{
            item.price = (item.originalPrice * Number(this.ratioPrice)/100).toString()
        })
        this.ratioPrice = ''
    }
    //已设置
    handelSetAllPrice(){
        this.projectTypeTableData_.forEach(item=>{
            item.price = (item.originalPrice * Number(this.ratioPrice_)/100).toString()
        })
        this.ratioPrice_ = ''
    }


    changInput(val) {

        val = this.handleOnInput(val, '2')
        this.ratioPrice = val
    }

    changInput_(val) {
        val = this.handleOnInput(val, '2')
        this.ratioPrice_ = val
    }
    handleOnInput(num,limit){
        const len1 = num.charAt(0)
        // 转化为数字形式--包含小数，负数
        // 先把非数字的都替换掉，除了数字和.
        num = num.replace(/[^\d.]/g, '')
        // 必须保证第一个为数字而不是.
        num = num.replace(/^\./g, '')
        // 保证只有出现一个.而没有多个.
        num = num.replace(/\.{2,}/g, '.')
        // 保证.只出现一次，而不能出现两次以上
        num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // 如果第一位是负号，则允许添加
        if (len1 === '-') {
            num = '-' + num
        }
        return num
    }

    addGiveStudentUserName() {
        this.adviserList.push({name: ''})
    }

    deleteAdviser(index) {
        this.adviserList.splice(index, 1)
    }

    // 论文项目佣金类型
    handleCommissionType(id, val) {
        this.$forceUpdate();
        for (const key in this.partnerInfo.projectDissertationCommissionList) {
            if (this.partnerInfo.projectDissertationCommissionList[key].projectDissertationId == id) {
                this.partnerInfo.projectDissertationCommissionList[key].priceOrRebateRatio = ''
            }
        }
    }
    // 获取合作伙伴详情
    async getMarketCooperationById() {
        const { marketCooperation } = await getMarketCooperationById({ id: this.partnerId, isUpdatedData: this.isUpdatedData }) as unknown as { marketCooperation }
        this.partnerInfo = marketCooperation
        this.payInfo = {...marketCooperation.marketCooperationAccount}
        this.marketCooperationAccount = marketCooperation.marketCooperationAccount
        if (!this.marketCooperationAccount.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!this.marketCooperationAccount.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }

        this.payInfo.type = (marketCooperation.marketCooperationAccount.types === '0' ? '对公账户' : marketCooperation.marketCooperationAccount.types === '1' ? '个人账户' : '')
        this.remoteCooperativePartnerMethod(marketCooperation.marketCooperationName)

        if(this.partnerInfo.isAsync == '0'){
            this.checkedLeval = false
        }
        if(this.partnerInfo.isAsync == '1'){
            this.checkedLeval = true
        }
        this.createUserRealName = marketCooperation.createUserRealName
        this.$set(this.partnerInfo, 'projectDissertationCommissionList', marketCooperation.marketCooperationProjectDissertationCommissionList)
        if(marketCooperation.marketCooperationAccount && marketCooperation.marketCooperationAccount.provinces){
            this.$set(this.payInfo, 'selectedArea', [marketCooperation.marketCooperationAccount.provinces, marketCooperation.marketCooperationAccount.city,marketCooperation.marketCooperationAccount.districts])
          } else {
            this.$set(this.payInfo, 'selectedArea', [])
            this.selectedOptions = []
          }
          if (marketCooperation.marketCooperationAccount && marketCooperation.marketCooperationAccount.others) {
            this.$set(this.payInfo,'selectedDetailArea', marketCooperation.marketCooperationAccount.others)
          } else {
            this.$set(this.payInfo,'selectedDetailArea', null)
          }
        for (const key in this.partnerInfo.projectDissertationCommissionList) {
            if (this.partnerInfo.projectDissertationCommissionList[key].commissionType == '') {
                this.partnerInfo.projectDissertationCommissionList[key].commissionType = '2'
            }
        }
        this.partnerInfo.marketCooperationCommissionList = this.partnerInfo.marketCooperationCommissionList.map(item => {
            const obj = { ...item }
            item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(item => Number(item)))
            if (this.partnerInfo.contractType === '1') {
                this.oldSouCourseTypeIdList = item.souCourseTypeIdList
                obj['souCourseTypeName'] = this.getMultipleSouCourseTypeName(item.souCourseTypeIdList)
            }
            return obj
        })

        this.$set(this.partnerInfo, 'shareUserIdList', marketCooperation.shareUserList.map(item => item.userId))
        this.oldShareUserIdList=marketCooperation.shareUserList.map(item => item.userId)
     
        // 佣金信息
        this.$set(this.partnerInfo, 'invoicePhone', marketCooperation.marketCooperationInvoice.phone)
        this.$set(this.partnerInfo, 'invoiceCode', marketCooperation.marketCooperationInvoice.code)
        this.$set(this.partnerInfo, 'invoiceAccount', marketCooperation.marketCooperationInvoice.account)
        this.$set(this.partnerInfo, 'invoiceAddress', marketCooperation.marketCooperationInvoice.address)
        this.$set(this.partnerInfo, 'invoiceBank', marketCooperation.marketCooperationInvoice.bank)
        this.$set(this.partnerInfo, 'invoiceTitle', marketCooperation.marketCooperationInvoice.title)
        this.$set(this.partnerInfo, 'invoiceType', marketCooperation.marketCooperationInvoice.types)
        this.$set(this.partnerInfo, 'directorUserId', marketCooperation.directorUserId)
        this.directorUserName = marketCooperation.directorUserRealName
        marketCooperation.shareUserList.forEach((item: any) => {
            this.shareUserList.push({
                id: item.userId,
                realName: item.userRealName,
            })
        })
        // 送生顾问信息
        if (marketCooperation.marketCooperationAdviserList.length === 0) {
            this.adviserList = [
                {name: ''}
            ]
        } else {
            this.adviserList = marketCooperation.marketCooperationAdviserList
        }


        // 删除没用的字段
        delete this.partnerInfo.marketCooperationInvoice
        delete this.partnerInfo.marketCooperationLogList
        // 记录需要对比的旧数据
        this.partnerInfo.marketCooperationCommissionList.forEach(item => {
            item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => Number(id)))
        })
        this.oldProjectDissertationCommissionList = JSON.parse(JSON.stringify(this.partnerInfo.projectDissertationCommissionList))
        this.oldMarketCooperationCommissionList = JSON.parse(JSON.stringify(this.partnerInfo.marketCooperationCommissionList))
        // 判断当前数据是不是导入且首次编辑的数据
        if (this.partnerInfo.contractType === '0' && this.partnerInfo.marketCooperationCommissionList[0].commissionType === '0' && this.partnerInfo.marketCooperationCommissionList[0].priceOrRebateRatio === '0') {
            this.isImport = true
        }
        this.partnerInfo.marketCooperationCommissionList.forEach(item => {
            item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => Number(id)))
        })
        this.getSelectedLabels()
    }



    // 获取论文项目列表
    async getProjectDissertationList() {
        const { projectDissertationList } = await getProjectDissertationList() as unknown as { projectDissertationList }
        this.partnerInfo.projectDissertationCommissionList = projectDissertationList.map(item => ({
            projectDissertationId: item.id,
            name: item.name,
            commissionType: '2',
            priceOrRebateRatio: ''
        }))
    }

    //  提交
    clickSubmit() {

        // 开票信息 如果有值 保存清空空格
        if (this.partnerInfo.invoiceCode) {
            this.partnerInfo.invoiceCode = this.clearBlank(this.partnerInfo.invoiceCode)
        }
        if (this.partnerInfo.invoiceTitle) {
            this.partnerInfo.invoiceTitle = this.clearBlank(this.partnerInfo.invoiceTitle)
        }
        if (this.partnerInfo.invoiceBank) {
            this.partnerInfo.invoiceBank = this.clearBlank(this.partnerInfo.invoiceBank)
        }
        if (this.partnerInfo.invoiceAccount) {
            this.partnerInfo.invoiceAccount = this.clearBlank(this.partnerInfo.invoiceAccount)
        }
        if (this.partnerInfo.invoiceAddress) {
            this.partnerInfo.invoiceAddress = this.clearBlank(this.partnerInfo.invoiceAddress)
        }
        if (this.partnerInfo.invoicePhone) {
            this.partnerInfo.invoicePhone = this.clearBlank(this.partnerInfo.invoicePhone)
        }


        // 验证论文项目信息
        let isError = false
        for (let i = 0; i < this.partnerInfo.projectDissertationCommissionList.length; i++) {
            const item = this.partnerInfo.projectDissertationCommissionList[i]
            isError = false
            if (item.commissionType !== '2' && (item.priceOrRebateRatio === '' || item.priceOrRebateRatio === null || item.priceOrRebateRatio === undefined || item.priceOrRebateRatio.length === 0)) {
                this.$message.error('论文项目信息不完整，论文名称: ' + item.name)
                isError = true
                break
            }
        }
        if (isError) return
        // 验证开票信息

        // if (!this.partnerInfo.invoiceType) { this.$message.error('开票类型不能为空'); return }
        // if (!this.partnerInfo.invoiceTitle) { this.$message.error('开票抬头不能为空'); return }
        // if (!this.partnerInfo.invoiceCode) { this.$message.error('纳税识别号不能为空'); return }
        // if (!this.partnerInfo.invoiceBank) { this.$message.error('开户行不能为空'); return }
        // if (!this.partnerInfo.invoiceAccount) { this.$message.error('开户账号不能为空'); return }
        // if (!this.partnerInfo.invoiceAddress) { this.$message.error('开户地址不能为空'); return }
        // if (!this.partnerInfo.invoicePhone) { this.$message.error('电话不能为空'); return }
        // 验证重名
        if (this.repeatErrortext) { this.$message.error('合作方名称已存在'); return }
        // 验证必填是否填写
        (this.$refs['ruleForm'] as HTMLFormElement).validate(valid => {
            if (valid) {
                this.partnerInfo.name=this.partnerInfo.name.replace(/\s*/g,"")
                let flag = true
                /*身份证号码是否存在 ，存在的话校验是否符合规则，不存在跳过*/
                if (this.payInfo.certificateNo) {
                    if (!getAgeByCardId(this.payInfo.certificateNo)) {
                        flag = false
                    }
                }
                /*如果是个人账户，正则校验手机号格式是否正确*/
                if (this.payInfo.type === '个人账户' && this.payInfo.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.payInfo.phoneNo))) {
                    this.$message.error('请输入正确的手机号');
                    flag = false
                }

                if (!flag) {
                    return
                }

                const bolArr = this.ladderIsError()
                if (bolArr.every(item => item)) {
                    if (this.partnerId) {
                        // this.partnerInfo.marketCooperationCommissionList.forEach(item => {
                        //     item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => String(id)))
                        // })
                        this.setMarketCooperationById()
                    } else {
                        this.setMarketCooperation()
                    }
                }
            }
        })
    }

    // 新建合作伙伴
    setMarketCooperation() {

        if (this.checkedLeval) {
            this.partnerInfo.isAsync = '1'
        }
        if (!this.checkedLeval) {
            this.partnerInfo.isAsync = '0'
        }

        let flag = true
        this.partnerInfo.adviserList = this.adviserList.filter(item => item.name)
        this.partnerInfo.marketCooperationCommissionList.map(item => {
            if(!item.commissionType){
                this.$message.error('佣金类型不可为空')
                flag = false
            }
        });
        this.partnerInfo = this.payInfo.id ? {
            ...this.partnerInfo,
            accountPayeeInfoId: this.payInfo.id,
            accountTypes: this.payInfo.type === '对公账户' ? '0' : this.payInfo.type === '个人账户' ? '1' : '',
            accountName: this.payInfo.name,
            accountCardNum: this.payInfo.cardNum,
            accountBranch: this.payInfo.branch,
            accountCertificateNo: this.payInfo.certificateNo,
            accountPhoneNo: this.payInfo.phoneNo
        } : this.partnerInfo
        if(this.payInfo.selectedArea && this.payInfo.selectedArea.length) {
            this.partnerInfo.accountProvinces = this.payInfo.selectedArea[0]
            this.partnerInfo.accountCity = this.payInfo.selectedArea[1]
            this.partnerInfo.accountDistricts = this.payInfo.selectedArea[2]
          }
          this.partnerInfo.accountOthers = this.payInfo.selectedDetailArea?this.payInfo.selectedDetailArea:''
        if (flag) {
            this.disabledButton = true
            this.loading = true
            setMarketCooperation(delNullProperty(this.partnerInfo)).then(res => {
                this.$message.success('合作伙伴新建成功，页面即将关闭')
                this.loading = false
                setTimeout(() => {
                    window.close()
                }, 1500)
            }).catch((err: Error) => {
                this.disabledButton = false
                this.loading = false
                if (err.message === '审批流报错') {
                    this.errorDialogShow = true
                }
            })
        }
    }

    // 编辑合作伙伴
    setMarketCooperationById() {
        this.disabledButton = true
        let flag = true
        // this.partnerInfo.marketCooperationCommissionList.forEach(item => {
        //     item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => String(id)))
        // })
        const isChange1 = JSON.stringify(JSON.parse(JSON.stringify(this.oldProjectDissertationCommissionList))) !== JSON.stringify(JSON.parse(JSON.stringify(this.partnerInfo.projectDissertationCommissionList)))
        const isChange2 = JSON.stringify(JSON.parse(JSON.stringify(this.oldMarketCooperationCommissionList))) !== JSON.stringify(JSON.parse(JSON.stringify(this.partnerInfo.marketCooperationCommissionList)))
        this.partnerInfo.marketCooperationCommissionList.map(item => {

            if(item.commissionType){
                if (item.commissionType == '0') {  //结算价
                    delete item.rebateType  //返点类型
                }
            }else{
                this.$message.error('佣金类型不可为空！')
                flag = false
            }

        })

        if(this.checkedLeval){
            this.partnerInfo.isAsync = '1'
        }
        if(!this.checkedLeval){
            this.partnerInfo.isAsync = '0'
        }

        this.adviserList.forEach((item: any, index: number) => {
            if (item.id && !item.name) {
                this.$message.error('请补充送生顾问')
                flag = false
            }
        })
        this.partnerInfo.adviserList = this.adviserList.filter(item => item.name)
        const newShareUserIdList= this.partnerInfo.shareUserIdList
      
        const newIds=newShareUserIdList.filter(c=>this.oldShareUserIdList.indexOf(c)==-1)
        const delIds=this.oldShareUserIdList.filter(c=>newShareUserIdList.indexOf(c)==-1)
        this.partnerInfo.shareUserIdList=newIds
        this.partnerInfo.delShareUserIdList=delIds

        for (const key in this.partnerInfo) {
            if (key == 'invoiceType' || key == 'invoiceTitle' || key == 'invoiceCode' || key == 'invoiceBank' || key == 'invoiceAccount' || key == 'invoiceAddress' || key == 'invoicePhone')
                if (this.partnerInfo[key] == '') {
                    this.partnerInfo[key] = null
                }
        }

        this.partnerInfo = {
            ...this.partnerInfo,
            accountPayeeInfoId: this.payInfo.id ? this.payInfo.id : '',
            accountTypes: this.payInfo.type === '对公账户' ? '0' : this.payInfo.type === '个人账户' ? '1' : '0',
            accountName: this.payInfo.name ? this.payInfo.name : '',
            accountCardNum: this.payInfo.cardNum ? this.payInfo.cardNum : '',
            accountBranch: this.payInfo.branch ? this.payInfo.branch : '',
            accountCertificateNo: this.payInfo.certificateNo ? this.payInfo.certificateNo : '',
            accountPhoneNo: this.payInfo.phoneNo ? this.payInfo.phoneNo : '',
            accountProvinces: '',
            accountCity: '',
            accountDistricts: '',
            accountOthers: ''
        }
        if(this.payInfo.selectedArea && this.payInfo.selectedArea.length) {
            this.partnerInfo.accountProvinces = this.payInfo.selectedArea[0]
            this.partnerInfo.accountCity = this.payInfo.selectedArea[1]
            this.partnerInfo.accountDistricts = this.payInfo.selectedArea[2]
          }
          this.partnerInfo.accountOthers = this.payInfo.selectedDetailArea?this.payInfo.selectedDetailArea:""
        if (flag === true) {
            this.loading = true
            setMarketCooperationById({isChange: ((isChange1 || isChange2) || this.isUpdatedData === '1') ? '1' : '0', ...this.partnerInfo}).then(res => {
                this.$message.success('合作伙伴编辑成功，页面即将关闭')
                this.loading = false
                setTimeout(() => { window.close() }, 1500)
            }).catch((err: Error) => {
                this.disabledButton = false
                this.loading = false
                if (err.message === '审批流报错') {
                    this.errorDialogShow = true
                }
            })
        }
    }

    // 验证返佣范围之间是否冲突
    ladderIsError() {
        const bolArr = this.partnerInfo.marketCooperationCommissionList.map((item, index) => {
            // 获取对应的 doms
            const doms = [...document.getElementsByClassName('ladder_box')[index].children[1].children]
            doms.splice(0, 1)
            // 当前不是阶梯的时候直接返回true
            if (!Array.isArray(item.rebateRatioList) || item.rebateRatioList.length === 0) return true
            // 当前是阶梯的时候验证是否冲突
            if (Array.isArray(item.rebateRatioList) && item.rebateRatioList.length > 0) {
                // 验证单个返佣是否有错误
                const arr = ladderItemError(item.rebateRatioList)
                arr.forEach((item, index) => {
                    doms[index].lastChild.textContent = ''
                    if (!item) doms[index].lastChild.textContent = '该返佣范围内出现错误，请修改'
                })
                // 单个返佣范围没有错误的时候，验证返佣范围之间是否冲突，
                if (arr.every(item => item)) {
                    // 只有返佣范围超过两个才有比较的意义
                    if (item.rebateRatioList.length >= 2) {
                        const arr = ladderRatioCheck(item.rebateRatioList)
                        for (let i = 1; i < arr.length; i++) {
                            doms[i].lastChild.textContent = ''
                            if (arr[i].bol) {
                                doms[arr[i].index1].lastChild.textContent = '该返佣范围与其他返佣范围冲突，请修改'
                                doms[arr[i].index2].lastChild.textContent = '该返佣范围与其他返佣范围冲突，请修改'
                                break
                            }
                        }
                        return arr.every(item => !item.bol)
                    } else { return true }
                } else { return false }
            }
        })
        return bolArr
    }

    // 合作伙伴名称查重
    handleDuplicateCheck() { 
        if(this.partnerInfo.name){
            this.duplicateCheckMarketCooperation()
        }else {
            this.repeatErrortext = ''
        }
    }
    async duplicateCheckMarketCooperation() {
        this.partnerInfo.name=this.partnerInfo.name.replace(/\s*/g,"")

        const { marketCooperation } = await duplicateCheckMarketCooperation(delNullProperty({ id: this.partnerId, name:this.partnerInfo.name })) as unknown as { marketCooperation: any[] }
        this.repeatTableData = marketCooperation
        if (marketCooperation.length > 0) {
            this.repeatErrortext = '合作伙伴重名'
        } else {
            this.repeatErrortext = ''
        }
    }

    // 选取的上级合作伙伴变化时
    async marketCooperationIdChange(val) {
        if ((val === undefined || val === null || val === '') && !this.partnerId) {
            this.partnerInfo.contractType = ''
            this.partnerInfo.marketCooperationCommissionList = [
                {
                    souCourseTypeName: '',
                    souCourseTypeIdList: [],
                    commissionType: '',
                    rebateType: '',
                    priceOrRebateRatio: '',
                    rebateRatioList: [],
                    projectAllGroupPriceList: [],
                    projectAllList: [],
                }
            ]
            this.partnerInfo.projectDissertationCommissionList = this.partnerInfo.projectDissertationCommissionList.map(item => {
                item.commissionType = '2'
                return item
            })
            return
        }
        // 当前操作是 新建合作伙伴/首次编辑导入的合作伙伴 的时候，拉取上级合作伙伴的佣金信息和论文信息并赋值
        if (!this.partnerId || this.isImport) {
            this.getPrevMarketCooperationById()
        }
    }

    // 获取上级合作伙伴的佣金信息和论文信息，并赋值给当前的合作伙伴
    async getPrevMarketCooperationById() {
        const { prevMarketCooperation } = await getPrevMarketCooperationById({ id: this.partnerInfo.marketCooperationId }) as unknown as { prevMarketCooperation: { contractType: string; marketCooperationCommissionList: any[]; marketCooperationProjectDissertationCommissionList: any[] } }
        this.partnerInfo.contractType = prevMarketCooperation.contractType
        this.partnerInfo.marketCooperationCommissionList = prevMarketCooperation.marketCooperationCommissionList
        this.partnerInfo.projectDissertationCommissionList = prevMarketCooperation.marketCooperationProjectDissertationCommissionList
        // 当合同类型是项目类型的时候获取每个项目类型的结算价
        if (this.partnerInfo.contractType === '1') {
            this.partnerInfo.marketCooperationCommissionList.forEach(item => {
                item.souCourseTypeIdList = item.souCourseTypeIdList.map(item => Number(item))
                item.souCourseTypeName = this.getMultipleSouCourseTypeName(item.souCourseTypeIdList)
            })
        }
    }

    // 编辑的时候获取项目类型对应的结算价
    async getPriceByProjectType(item) {
        if (item.commissionType === '0' && item.souCourseTypeId) {
            const obj = { souCourseTypeIdList: item.dialogSouCourseTypeId }
            if (this.partnerId) obj['id'] = this.partnerId
            const data = await getProjectAllGroupPriceListBySouCourseTypeId(obj) as unknown as { projectAllGroupPriceList: any }
            this.projectTypeTableData = data.projectAllGroupPriceList.filter(item => item.isSetting === false)
            this.projectTypeTableData_ = data.projectAllGroupPriceList.filter(item => item.isSetting === true)
            this.dialogSouCourseTypeId = item.souCourseTypeId
            this.projectTypePriceDialogSave()
        }
    }

    // 删除条件
    delCondition(index: number, ladderIndex: number, item, ladderItem, type) {
        if (type === 'start') {
            if (ladderIndex === 0) {
                this.$message.error('默认条件不可删除')
                return
            } else {
                if ('endCondition' in ladderItem) {
                    this.$message.error('当结束条件存在的时候，开始条件不可删除')
                } else {
                    item.rebateRatioList.splice(ladderIndex, 1)
                }
            }
        } else {
            delete ladderItem.endCondition
            delete ladderItem.endNum
            this.$forceUpdate()
        }
    }

    // 返点类型发生改变时
    rebateTypeChange(val, index) {
        if (val !== '0') {
            this.$set(this.partnerInfo.marketCooperationCommissionList[index], 'rebateRatioList', [])
            this.$set(this.partnerInfo.marketCooperationCommissionList[index].rebateRatioList, 0, {
                startCondition: '',
                startNum: '',
                rebateRatio: ''
            })
        }
        if (val === '0') {
            this.partnerInfo.marketCooperationCommissionList[index].rebateRatioList = []
        }
        this.$forceUpdate()
    }

    // 添加条件
    addCondition(index: number, ladder_index: number, data) {
        if (!data.startCondition || (data.startNum === '' || data.startNum === undefined || data.startNum === null)) {
            this.$message.error('请将开始条件填写完整')
            return
        }
        this.$set(this.partnerInfo.marketCooperationCommissionList[index].rebateRatioList[ladder_index], 'endCondition', '')
        this.$set(this.partnerInfo.marketCooperationCommissionList[index].rebateRatioList[ladder_index], 'endNum', '')
    }

    // 添加返佣范围
    addLadder(index: number) {
        this.partnerInfo.marketCooperationCommissionList[index].rebateRatioList.push({
            startNum: undefined,
            startCondition: '',
            rebateRatio: ''
        })
    }

    // 合同类型改变触发
    contractTypeChange() {
        this.partnerInfo.marketCooperationCommissionList.splice(0)
        this.$set(this.partnerInfo.marketCooperationCommissionList, 0, {
            souCourseTypeName: '',
            souCourseTypeIdList: [],
            commissionType: '',
            rebateType: '',
            priceOrRebateRatio: '',
            rebateRatioList: [],
            projectAllGroupPriceList: [],
            projectAllList: [],
        })
    }

    // 选中的项目类型发生改变时
    souCourseTypeIdChange() {
        // this.$nextTick(() => {
        //     this.partnerInfo.marketCooperationCommissionList = this.partnerInfo.marketCooperationCommissionList.filter((item) => this.souCourseTypeIdList.includes(item.souCourseTypeId))
        //     const arr = this.partnerInfo.marketCooperationCommissionList.map(item => item.souCourseTypeId)
        //     this.souCourseTypeIdList.forEach(item => {
        //         if (arr.includes(item) === false) {
        //             this.partnerInfo.marketCooperationCommissionList.push({
        //                 souCourseTypeName: this.souCoueTypeList.filter(souCoueType => souCoueType.id === item)[0].name,
        //                 souCourseTypeId: item,
        //                 commissionType: '',
        //                 rebateType: '',
        //                 priceOrRebateRatio: '',
        //                 rebateRatioList: [],
        //                 projectAllGroupPriceList: [],
        //                 projectAllList: [],
        //             })
        //         }
        //     })
        // })
    }
    async newProjectTypeTableData(id){
        this.projectTypeTableData = []  //未设置
        this.projectTypeTableData_ = [] //已设置
        const obj = { souCourseTypeIdList: id }
        if (this.partnerId) obj['id'] = this.partnerId
        const data = await getProjectAllGroupPriceListBySouCourseTypeId(obj) as unknown as { projectAllGroupPriceList: any }
        this.projectTypeTableData = data.projectAllGroupPriceList.filter(item => item.isSetting === false) //未设置
        this.projectTypeTableData_ = data.projectAllGroupPriceList.filter(item => item.isSetting === true) //已设置
        // this.oldIdList = []
    }
    // 多选项目组合 项目类型改变
    multipleSouCourseTypeIdChange(souCourseTypeIdList: number[]) {
        // this.oldIdList = []
        if(souCourseTypeIdList != undefined){
            souCourseTypeIdList.forEach(item => {
                if(this.souCourseTypeIdList.includes(item) === false) {
                    // this.souCourseTypeIdList.push(item)
                    souCourseTypeIdList.sort((x,y)=> x - y) // 正序
                }
            })
            // this.oldIdList = souCourseTypeIdList
        }
        // 改变对应佣金模块的项目名称
        if(this.partnerInfo.marketCooperationCommissionList.length){
            this.partnerInfo.marketCooperationCommissionList.forEach(item => {
                if(item.souCourseTypeIdList.length == 0){
                    item.rebateType = ''
                    item.commissionType = ''
                }
                if (item.souCourseTypeIdList === souCourseTypeIdList) {
                    item.souCourseTypeName = this.getMultipleSouCourseTypeName(souCourseTypeIdList)
                }
            })
        }

    }

    // 生成 souCourseTypeName
    getMultipleSouCourseTypeName(souCourseTypeIdList: number[]): string {
        let souCourseTypeName = ''
        this.souCoueTypeList.forEach((item) => {
            if (souCourseTypeIdList.includes(item.value)) {
                const nameArr = souCourseTypeName.split('+')
                // 判断当前生成的名字中有几个 +
                if (nameArr.length === souCourseTypeIdList.length) {
                    souCourseTypeName += item.label
                } else {
                    souCourseTypeName += item.label + '+'
                }
            }
        })
        return souCourseTypeName
    }

    // 添加组合佣金
    addMultipleCommission() {
        this.partnerInfo.marketCooperationCommissionList.push({
            souCourseTypeName: '',
            souCourseTypeIdList: [],
            commissionType: '',
            rebateType: '',
            priceOrRebateRatio: '',
            rebateRatioList: [],
            projectAllGroupPriceList: [],
            projectAllList: [],
        })
    }

    // 佣金类型发生改变
    async commissionTypeChange(item) {
        this.$set(item, 'priceOrRebateRatio', '')
        this.$set(item, 'rebateType', '')
        // 是项目类型 && 是结算价
        if (item.commissionType === '0' && item.souCourseTypeIdList.length > 0) {
            // 清空筛选
            this.projectPriceFilterObj.schoolBeginAt = []
            this.projectPriceFilterObj.souCourseName = ''
            this.projectPriceFilterObj.souCoursePrice = ''
            this.projectPriceFilterObj.souTeacherName = ''

            delete item.rebateType
            delete item.priceOrRebateRatio

            if(JSON.stringify(item.souCourseTypeIdList) == JSON.stringify(this.dialogSouCourseTypeId)){
                this.projectTypeTableData = item.projectAllGroupPriceList.filter(item => item.isSetting === false) //未设置
                this.projectTypeTableData_ = item.projectAllGroupPriceList.filter(item => item.isSetting === true)  //已设置
            }else {
                this.newProjectTypeTableData(item.souCourseTypeIdList)
                // item.projectAllGroupPriceList = []
            }

            // if (Array.isArray(item.projectAllGroupPriceList) && item.projectAllGroupPriceList.length > 0) {
            //     if(this.oldIdList.length){
            //         this.newProjectTypeTableData(this.oldIdList)
            //         // this.projectTypeTableData = item.projectAllGroupPriceList.filter(item => item.isSetting === false)
            //         // this.projectTypeTableData_ = item.projectAllGroupPriceList.filter(item => item.isSetting === true)  //已设置
            //     } else {
            //         this.projectTypeTableData = []
            //         this.projectTypeTableData_ = item.projectAllGroupPriceList   //已设置
            //     }
            //     // this.projectTypeTableData = [] //未设置


            // } else {
            //     // 没有保存
            //     const obj = { souCourseTypeIdList: item.souCourseTypeIdList }
            //     if (this.partnerId) obj['id'] = this.partnerId
            //     const data = await getProjectAllGroupPriceListBySouCourseTypeId(obj) as unknown as { projectAllGroupPriceList: any }
            //     this.projectTypeTableData = data.projectAllGroupPriceList.filter(item => item.isSetting === false)
            //     this.projectTypeTableData_ = data.projectAllGroupPriceList.filter(item => item.isSetting === true)
            // }
            // 如果是编辑的话的就拿一份数据到旧数据中方便比较
            if (this.partnerId) {
                this.oldMarketCooperationCommissionList.forEach(elm => {
                    if (elm.souCourseTypeId === item.souCourseTypeId) {
                        elm.projectAllGroupPriceList = [...this.projectTypeTableData, ...this.projectTypeTableData_].map(itme => ({ originalPrice: itme.originalPrice, price: itme.price || itme.originalPrice }))
                        elm.projectAllList = []
                    }
                })
            }
            this.projectTypeDialogTitle = item.souCourseTypeName
            this.projectTypeDialogShow = true
            this.dialogSouCourseTypeId = item.souCourseTypeIdList
        }
        this.$forceUpdate()
    }

    // 获取项目类型对应的价格列表
    editProjectTypePriceDialogShowChange(type: number) {
        // 查看结果并微调
        if (type === 1) {
            this.projectPriceDialogShow = true
            this.projectPriceFilterObj.page = 1
            this.getProjectAllListBySouCourseTypeId()
            this.projectTypePriceDialogSave()
        }
        // 上一步
        if (type === 2) {
            this.projectPriceDialogShow = false
            this.projectTypeDialogShow = true
            this.getProjectAllListBySouCourseTypeId()
        }
    }

    // 获取项目类型对应的项目列表
    async getProjectAllListBySouCourseTypeId() {
        const obj = {}
        for (const key in this.projectPriceFilterObj) {
            obj[key] = this.projectPriceFilterObj[key]
        }
        if (Array.isArray(this.projectPriceFilterObj.schoolBeginAt) && this.projectPriceFilterObj.schoolBeginAt.length > 1) {
            obj['schoolBeginAt'] = formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[1]))
        } else {
            obj['schoolBeginAt'] = ''
        } const { allNum, projectAllList } = await getProjectAllListBySouCourseTypeId(delNullProperty({
            ...obj,
            souCourseTypeIdList: this.dialogSouCourseTypeId, projectAllGroupPriceList: [...this.projectTypeTableData_, ...this.projectTypeTableData].map(itme => ({
                originalPrice: itme.originalPrice, price: itme.price || itme.originalPrice
            }))
        })) as unknown as { allNum: number; projectAllList: any[] }
        this.total = allNum
        this.projectPricetableData = projectAllList.map(item => {
            const date = new Date(item.souCourseSchoolBegin)
            const str = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
            return { date: str, ...item }
        })
    }


    handleSizeChange(limit: number) {
        this.projectPriceFilterObj.limit = limit
        this.tableKey = Math.random()
        this.getProjectAllListBySouCourseTypeId()
    }

    handleCurrentChange(page) {
        this.projectPriceFilterObj.page = page
        this.tableKey = Math.random()
        this.getProjectAllListBySouCourseTypeId()
    }

    // 项目类型结算价保存
    projectTypePriceDialogSave() {
        this.partnerInfo.marketCooperationCommissionList.forEach(item => {
            if (JSON.stringify(item.souCourseTypeIdList) === JSON.stringify(this.dialogSouCourseTypeId)) {
                item.projectAllGroupPriceList = [...this.projectTypeTableData, ...this.projectTypeTableData_].map(itme => ({ isSetting: true, originalPrice: itme.originalPrice, price: itme.price || itme.originalPrice }))
                item.projectAllList = []
            }
        })
        this.projectTypeDialogShow = false
        // this.projectTypeTableData = []
    }

    projectPriceChange(row) {
        this.partnerInfo.marketCooperationCommissionList.forEach(item => {
            if (JSON.stringify(item.souCourseTypeIdList) === JSON.stringify(this.dialogSouCourseTypeId)) {
                if ('projectAllList' in item) {
                    item.projectAllList.push({ id: row.id, price: row.price })
                } else {
                    item.projectAllList = []
                    item.projectAllList.push({ id: row.id, price: row.price })
                }
            }
        })
    }

    // 结束条件下来列表中的禁用选项
    endConditionOptionDisabled(val: string, start: string) {
        if (start === '等于') {
            return true
        } else {
            if (val === '等于') return true
            if (start.includes('大于')) {
                if (val.includes('大于')) return true
            }
            if (start.includes('小于')) {
                if (val.includes('小于')) return true
            }
        }
    }

    // 删除某一块佣金信息
    delCommissionItem(index: number) {
        if(this.partnerInfo.marketCooperationCommissionList.length === 1) {
            this.$message.error('剩余一条组合信息不能删除')
            return
        }
        this.partnerInfo.marketCooperationCommissionList.splice(index, 1)
    }

    // 关闭当前页面
    closePage() {
        window.close()
    }
    handleOninput(value,type){
        let str = value;
        const len1 = str.substr(0, 1);
        const len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") { str = ""; }
        if (len1 == "+") { str = ""; }
        if (len1 == "-") { str = ""; }

        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            const str_ = str.substr(str.indexOf(".") + 1);
            if (str_.indexOf(".") != -1) {
                str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
        if(type == '2'){
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, "$1"); // 小数点后只能输 2 位
            // str = str.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, "$1"); // 小数点后只能输 3 位
        }
        return str;
    }

    async getMarketCooperationPrevLevel() {
        const data: any = await getMarketCooperationPrevLevel(delNullProperty(
                {
                    page: this.marketLevelPage,
                    limit: this.marketLevelSize,
                    id: this.partnerId,
                    name: this.cooperativePartnerName
                }
            )
        )

            this.marketCooperationIdList = [...this.marketCooperationIdList, ...data.marketCooperationList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.marketCooperationIdList.length; i++) {
            if (!obj[this.marketCooperationIdList[i].id]) {
                result.push(this.marketCooperationIdList[i]);
                obj[this.marketCooperationIdList[i].id] = true;
            }
        }
        this.marketCooperationIdList = result

    }


    async remoteCooperativePartnerMethod(query: any) {
        this.cooperativePartnerName = query
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        if (query !== '') {
            const result: any = await getMarketCooperationPrevLevel(
                {
                    page: this.marketLevelPage,
                    limit: this.marketLevelSize,
                    name: query,
                    id : this.partnerId
                }
            )
          this.marketCooperationIdList = result.marketCooperationList
        }
    }



    clearCooperativePartner() {
        this.marketCooperationIdList = []
        this.partnerInfo.marketCooperationId = null
        // this.sourceName = ''
        this.cooperativePartnerName = null
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        this.getMarketCooperationPrevLevel()
    }

    cooperativePartnerLoadmore() {
        this.marketLevelPage = 1
        this.marketLevelSize += 20
        this.getMarketCooperationPrevLevel();
    }

    changedirectorUserId(e){
        this.partnerInfo.directorUserId = e.id
    }

    changeshareUserIdList(e){
        this.partnerInfo.shareUserIdList = e.id
    }

    /*
    * 新增账户打开弹窗*/
    clickNewAccount(){
        this.newAccountDialog = true
        this.getBranchList(); //开户网点
    }

    // 开户网点
    async getBranchList() {
        const objs = {
            name: this.searchBranchName,
            page: this.branchPage,
            limit: this.branchLimit,
        }
        const data: any = await getBranchList(delNullProperty(objs))
        this.branchInfoList = [...this.branchInfoList, ...data.branchList]
        const result = []
        const obj = {}
        for(let i =0; i<this.branchInfoList.length; i++){
            if(!obj[this.branchInfoList[i].name]){
                result.push(this.branchInfoList[i]);
                obj[this.branchInfoList[i].name] = true;
            }
        }
        this.branchInfoList = result
    }

    async handlePayInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchName) && !this.payInfo.name){
            this.searchName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.name){
            if (this.searchCardName && this.payInfo.cardNum) {
                this.searchName = this.payInfo.name
                this.payeeInfoList = []
                this.payInfo.page = 1
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
    }

    async handleRemotePayInfo (query: any) {
        this.searchName = query.trim();
        this.payInfo.page = 1
        this.payInfo.limit = 20
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
            this.payeeInfoList = []
            this.payInfoList();
        }
    }
    // 开户名称列表
    async payInfoList() {
        const objs = {
            name: this.searchName,
            cardNum: this.searchCardName,
            page: this.payInfo.page,
            limit: this.payInfo.limit,
        }
        const data: any = await payInfoList(delNullProperty(objs))
        this.payeeInfoList = [...this.payeeInfoList, ...data.payeeInfoList]
        const result = []
        const obj = {}
        for(let i =0; i<this.payeeInfoList.length; i++){
            if(!obj[this.payeeInfoList[i].name]){
                result.push(this.payeeInfoList[i]);
                obj[this.payeeInfoList[i].name] = true;
            }
        }
        this.payeeInfoList = result
    }

    handlePayInfoLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }

    handleClearPayInfo() {
        this.searchName = null
        this.searchCardName = null
        this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.payeeInfoId = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        /*
        * 如果是个人账户清空*/
        this.payInfo.certificateNo = ''
        this.payInfo.phoneNo = ''
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
        this.payInfoList()
    }

    // 开户名称
    handlePayInfoChange (indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        const obj = this.payeeInfoList.find((item,index)=> item.id === indexId);
        this.payInfo.name = obj.name
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.type = obj.type
        this.payInfo.payeeInfoId = obj.id;

        this.$set(this.payInfo, 'certificateNo', obj.certificateNo)
        this.$set(this.payInfo, 'phoneNo', obj.phoneNo)
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
        if (obj.certificateNo) {
            this.certificateNoDisabled = true
        } else {
            this.certificateNoDisabled = false
        }
        if (obj.phoneNo) {
            this.phoneNoDisabled = true
        } else {
            this.phoneNoDisabled = false
        }
        //    crm 和 易快报不同步 切换的时候要把请求回来的数据赋值
        if (this.marketCooperationAccount && this.marketCooperationAccount.payeeInfoId && (indexId == this.marketCooperationAccount.payeeInfoId)) {
            // this.$set(this.payInfo, 'phoneNo', this.marketCooperationAccount.phoneNo)
            // this.$set(this.payInfo, 'certificateNo', this.marketCooperationAccount.certificateNo)
            if (!this.payInfo.phoneNo) {
                this.$set(this.payInfo, 'phoneNo', this.marketCooperationAccount.phoneNo)
            }
            if (!this.payInfo.certificateNo) {
                this.$set(this.payInfo, 'certificateNo', this.marketCooperationAccount.certificateNo)
            }
            if (this.marketCooperationAccount.certificateNo) {
                this.certificateNoDisabled = true
            } else {
                this.certificateNoDisabled = false
            }
            if (this.marketCooperationAccount.phoneNo) {
                this.phoneNoDisabled = true
            } else {
                this.phoneNoDisabled = false
            }
        }
    }

    // 银行卡号
    async handlePayCardInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchCardName) && !this.payInfo.cardNum){
            this.searchCardName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.cardNum){
            if (this.searchName && this.payInfo.name) {
                this.searchCardName = this.payInfo.cardNum
                this.payInfo.page = 1
                this.payeeInfoList = []
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }

            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
    }

    async handleRemotePayCard(query: any) {
        this.searchCardName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: query})
            this.payeeInfoList = result.payeeInfoList
        } else {
            this.payeeInfoList = []
            this.payInfoList();
        }
    }

    handleClearPayCard() {
        this.payInfo.name = ''
        this.searchCardName = null
        this.searchName = null
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.payeeInfoId = ''

        /*
       * 如果是个人账户清空*/
        this.payInfo.certificateNo = ''
        this.payInfo.phoneNo = ''

        this.payInfoList()
    }

    handlePayCardLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }

    // 银行卡号
    handlePayChangeCard(indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        const obj = this.payeeInfoList.find((item, index) => item.id === indexId)
        this.payInfo.name = obj.name
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        this.payInfo.type = obj.type

        this.$set(this.payInfo, 'certificateNo', obj.certificateNo)
        this.$set(this.payInfo, 'phoneNo', obj.phoneNo)
        if (obj.certificateNo) {
            this.certificateNoDisabled = true
        } else {
            this.certificateNoDisabled = false
        }
        if (obj.phoneNo) {
            this.phoneNoDisabled = true
        } else {
            this.phoneNoDisabled = false
        }

        //    crm 和 易快报不同步 切换的时候要把请求回来的数据赋值
        if (this.marketCooperationAccount && this.marketCooperationAccount.payeeInfoId && (indexId == this.marketCooperationAccount.payeeInfoId)) {
            // this.$set(this.payInfo, 'phoneNo', this.marketCooperationAccount.phoneNo)
            // this.$set(this.payInfo, 'certificateNo', this.marketCooperationAccount.certificateNo)
            if (!this.payInfo.phoneNo) {
                this.$set(this.payInfo, 'phoneNo', this.marketCooperationAccount.phoneNo)
            }
            if (!this.payInfo.certificateNo) {
                this.$set(this.payInfo, 'certificateNo', this.marketCooperationAccount.certificateNo)
            }
            if (this.marketCooperationAccount.certificateNo) {
                this.certificateNoDisabled = true
            } else {
                this.certificateNoDisabled = false
            }
            if (this.marketCooperationAccount.phoneNo) {
                this.phoneNoDisabled = true
            } else {
                this.phoneNoDisabled = false
            }
        }
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
    }

    changeTypes(val) {
        console.log('val',val)
    }


    async handleBranchInfo(){
        if((this.branchInfoList.length == 0 || !this.searchBranchName) && !this.branch){
            this.searchBranchName = null
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.searchBranchName })
            this.branchInfoList = result.branchList
        }
        if(this.branch){
            this.branchInfoList = []
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.branch })
            this.branchInfoList = result.branchList
        }
    }

    async handleRemoteBranch (query: any) {
        this.searchBranchName = query.trim();
        this.branchPage = 1
        this.branchLimit = 20
        if (query !== '') {
            const result: any = await getBranchList({page: this.branchPage,  name: query })
            this.branchInfoList = result.branchList
        } else {
            this.branchInfoList = []
            this.getBranchList();
        }
    }

    handleBranchLoadmore() {
        this.branchPage ++
        this.getBranchList();
    }

    handleBranchChange (val) {
        this.branch = val
    }

    doCancel(){
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.newAccountDialog = false
    }
    // 新增账户确认
    async handleConfirmAccount() {
        if (this.type === '' ||  this.name === ''|| this.cardNum === ''|| this.branch === '') {
            this.$message.error(`请将${this.type === '' ? '账户类型，' : ''}${this.name === '' ? '开户名称，' : ''}${this.cardNum === '' ? '银行卡号，' : ''}${this.branch === '' ? '开户网点，' : ''}填写完整`)
            return
        }
        if((this.type === 'PERSONAL'&&this.certificateNo=='')|| (this.type === 'PERSONAL'&&this.phoneNo=='')){
            this.$message.error(`请将${this.certificateNo === '' ? '身份证号，' : ''}${this.phoneNo === '' ? '手机号，' : ''}填写完整`)
            return
        }
        let flag = true
        if (this.type === 'PERSONAL') {
            /*身份证号码校验是否符合规则*/
            if (!getAgeByCardId(this.certificateNo)) {
                flag = true
                return
            }
            /*如果是个人账户，正则校验手机号格式是否正确*/
            if (this.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNo))) {
                this.$message.error('请输入正确的手机号');
                flag = false
            }
        }
        if (!flag) {
            return
        }

        const obj = {
            type: this.type,
            name: this.name,
            cardNum: this.cardNum,
            branch: this.branch,
            certificateNo: this.certificateNo,
            phoneNo: this.phoneNo,
        }
        const { payeeInfoId } = await setPayeeInfo(delNullProperty(obj)) as unknown as { payeeInfoId: string}
        this.payInfo.id = payeeInfoId
        this.payInfo.name = this.name
        this.payInfo.cardNum = this.cardNum
        this.payInfo.branch = this.branch
        this.payInfo.certificateNo = this.certificateNo
        this.payInfo.phoneNo = this.phoneNo
        this.$set(this.payInfo, 'certificateNo', this.certificateNo)
        this.$set(this.payInfo, 'phoneNo', this.phoneNo)
        if (this.certificateNo) {
            this.certificateNoDisabled = true
        } else {
            this.certificateNoDisabled = false
        }
        if (this.phoneNo) {
            this.phoneNoDisabled = true
        } else {
            this.phoneNoDisabled = false
        }
        this.payInfo.type = this.type && this.type == 'PUBLIC' ? '对公账户' : this.type && this.type == 'PERSONAL' ? '个人账户': ''
        this.newAccountDialog = false

        //     清空输入框账户信息
        this.type = '' //账户类型
        this.name = '' //开户名称
        this.cardNum = '' //银行卡号
        this.branch = '' //开户网点
        this.phoneNo = '' //手机号
        this.certificateNo = ''
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
    }
    closeSyncDialog(){
        this.syncDialogVisible = false
    }

    handleClearBranch() {
        this.searchBranchName = null
        this.branch = ''
        this.branchPage = 1
        this.getBranchList()
    }

    changeType(val){
        this.certificateNo = ''
        this.phoneNo = ''
    }


    /*去除所有空格*/
    clearBlank(str: string) {
        return str.replace(/\s+/g, '')
    }

    changeCode(val) {
        this.partnerInfo.invoiceCode = this.clearBlank(val)
    }

    changeTitle(val) {
        this.partnerInfo.invoiceTitle = this.clearBlank(val)
    }


    changeBank(val) {
        this.partnerInfo.invoiceBank = this.clearBlank(val)
    }

    changeAccount(val) {
        this.partnerInfo.invoiceAccount = this.clearBlank(val)
    }

    changeAddress(val) {
        this.partnerInfo.invoiceAddress = this.clearBlank(val)
    }

    changePhone(val) {
        this.partnerInfo.invoicePhone = this.clearBlank(val)
    }
    
    handleChange(value) {

        // 如果需要获取中文名称，可以通过以下方式
        const province = this.findLabelByValue(this.options, value[0])
        const city = this.findLabelByValue(province.children, value[1])
        const district = this.findLabelByValue(city.children, value[2])
        this.payInfo.selectedArea = [province.label,city.label,district.label]
      }
      // 省市区联动
      getSelectedLabels() {
        if (this.payInfo.selectedArea.length !==3) return []
        const province = this.options.find(item => item.label === this.payInfo.selectedArea[0])
        // 兼容小程序地址
        let city = null
        if(this.payInfo.selectedArea[1]===this.payInfo.selectedArea[0]) {
             city = province.children.find(item => item.label === '市辖区')
        } else {
             city = province.children.find(item => item.label.includes(this.payInfo.selectedArea[1]))
        }
        let district = city.children.find(item => item.label.includes(this.payInfo.selectedArea[2]))
          //   如果没有第三级 则回显前两级别，并补充第三级为'—'
          if (!district) {
              this.payInfo.selectedArea = [province.label, city.label, '—']
              district = {label: '—', value: city.value + '00'}
          }
        this.selectedOptions = [province.value, city.value, district.value]
      }
      // 根据value查找对应的label
      findLabelByValue(arr, value) {
        return arr.find(item => item.value === value)
      }

    @Watch('userModuleData')
    handle(val) {
        if (!this.partnerId) {
            this.partnerInfo.directorUserId = this.partnerInfo.directorUserId ? this.partnerInfo.directorUserId : val.userid
            this.directorUserName = this.directorUserName ? this.directorUserName : val.username
        }
    }

}
